import { config } from "../env";
import {
  Delete,
  DeleteWithPayload,
  get,
  patch,
  post,
  postFileUpload,
  put,
  putFileUpload,
} from "./helpers/http-handler";

// Accounts
export const vendorReportsAccount = (queryRequest: string) =>
  get(`${config.API_URL}/vendor-checkpoint/audit/score?${queryRequest}`);

export const getManageAuditScoreFilter = (queryRequest: string) =>
  get(`${config.API_URL}/vendor-checkpoint/audit/score/filter?${queryRequest}`);

export const getVendorReportComplianceScoreCard = (queryRequest: string) =>
  get(`${config.API_URL}/vendor-checkpoint/audit/report?${queryRequest}`);

export const exportManageAudit = (queryRequest: string) =>
  get(
    `${config.API_URL}/vendor-checkpoint/export/managa-audit?${queryRequest}`
  );

export const downloadVendorComplianceMaster = (payload: string) =>
  post(`${config.API_URL}/reports/export-vendor-compliance`, payload);
